import React, { PropsWithChildren } from 'react'
import { styled } from '~/app/components'
import ReceiptBottom from '~/app/imgs/bd-receipt-bottom.svg?inline'
import SubHeader from '~/app/components/common/SubHeader/SubHeader'

/**
 * PaymentInformation component
 * author: soojin.oh
 */

// type definitions
type ReceiptCardProps = {
  title?: string
  className?: string
  isDisabledViewDetail?: boolean
} & Pick<React.HTMLProps<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div<{ isDisabledViewDetail?: boolean }>`
  background: ${({ theme }) => theme.color.white};
  margin: 2rem 1rem 1rem;
  position: relative;
  box-shadow: ${({ isDisabledViewDetail, theme }) =>
    isDisabledViewDetail ? 'none' : `0 0.2rem 0.2rem 0 ${theme.color.black_op10}`};
  padding-bottom: 2rem;

  ::after {
    content: '';
    border-bottom: 0.9rem solid transparent;
    border-image: url(${ReceiptBottom}) 0 0 100% 0 round;
    position: relative;
    bottom: -2.4rem;
    display: block;
    margin: 0 2rem 0;
  }
`

// PaymentInformation component
const ReceiptCard = function ({
  title,
  className,
  style,
  children,
  isDisabledViewDetail,
}: PropsWithChildren<ReceiptCardProps>) {
  return (
    <Container className={className} style={style} isDisabledViewDetail={isDisabledViewDetail}>
      {title && <SubHeader title={title} hasBottomContent />}
      {children}
    </Container>
  )
}

export default ReceiptCard
